import React from "react";
import MemboticLogoWhite from "../../assets/MemboticLogoWhite.png";
import { Link, useNavigate } from "react-router-dom";
import {
  ChevronCompactRight,
  Facebook,
  Instagram,
  Twitter,
} from "react-bootstrap-icons";
import { useAuthContext } from "../../hooks/useAuthContext";
import "./Footer.css";
export default function Footer() {
  const navi = useNavigate();
  const { user } = useAuthContext();

  return (
    <div style={{ backgroundColor: "#12384d" }}>
      <div className="container-fluid">
        <div className="row pt-5 mx-5">
          <div className="col">
            <Link    onClick={() => {
                window.scrollTo(0, 0);
                navi("/searchclubs");
              }} to="/">
              <img
                src={MemboticLogoWhite}
                className="logo"
                alt="Membotic - All your fitness clubs and activities together"
                title="Membotic - All your fitness clubs and activities together"
              />
            </Link>
            <div className="d-flex">
           
              {/* <Facebook className="social-icon" />
              <Twitter className="social-icon" />
              <Instagram className="social-icon" /> */}
            </div>
          </div>
          <div className="col">
            <div
              onClick={() => {
                window.scrollTo(0, 0);
                navi("/searchclubs");
              }}
              className="red-button my-4"
            >
              <Link className="fw-bold">SEARCH CLUBS </Link>
            </div>
            {!user && (
              <>
                {" "}
                <div
                  className="red-button  my-4"
                  onClick={() => {window.scrollTo(0, 0);   navi("/register")}}
              
                >
                  <Link className="mx-1 fw-bold">REGISTER & JOIN</Link>
                </div>
                <div
                  className="red-button  my-4"
                  onClick={() => {window.scrollTo(0, 0);
                    navi("/login");
                  }}
                >
                  <Link className="mx-1 fw-bold">SIGN IN</Link>
                </div>{" "}
              </>
            )}
          </div>
          <div className="col hover-effect link-hover-effect">
            <div className="d-flex mt-4" onClick={() => window.scrollTo(0, 0)}>
              <ChevronCompactRight className="mt-1" /> <Link to="/">Home</Link>
            </div>
            {/* <div className="d-flex">
              <ChevronCompactRight className="mt-1" /> <Link to="/faq">FAQ</Link>
            </div> */}
            <div className="d-flex" onClick={() => window.scrollTo(0, 0)}>
              <ChevronCompactRight className="mt-1" />{" "}
              <Link to="/aboutUs">About</Link>
            </div>
            <div className="d-flex" onClick={() => window.scrollTo(0, 0)}>
              <ChevronCompactRight className="mt-1" />{" "}
              <Link to="/Pricing">Pricing</Link>
            </div>
            <div className="d-flex" onClick={() => window.scrollTo(0, 0)}>
              <ChevronCompactRight className="mt-1" />{" "}
              <Link to="/whoismemboticfor">Use Cases</Link>
            </div>
            <div className="d-flex" onClick={() => window.scrollTo(0, 0)}>
              <ChevronCompactRight className="mt-1" />{" "}
              <Link to="/Features">Features</Link>
            </div>
            <div className="d-flex" onClick={() => window.scrollTo(0, 0)}>
              <ChevronCompactRight className="mt-1" />{" "}
              <Link to="/contactUs">Contact Us</Link>
            </div>
        
          </div>
        </div>
        <div className="row">
  <div className="d-flex justify-content-between w-100">
    <div className="d-flex link-hover-effect">
      <Link onClick={() => window.scrollTo(0, 0)} to="/privacyPolicy">
        Privacy Policy
      </Link>
      <p className="text-white mx-1 mb-0">|</p>
      <Link onClick={() => window.scrollTo(0, 0)} to="/termsofUse">
        Terms Of Use
      </Link>
    </div>
    <div className="text-white ms-auto">
      &copy; Membotic {new Date().getFullYear()}
    </div>
  </div>
</div>
      </div>
    </div>
  );
}
